import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { Habilitation } from '../../core/models/habilitation.model';
import { environment } from 'src/environments/environment';
import { jwtDecode } from 'jwt-decode';
const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
@Injectable({ providedIn: 'root' })
export class HabilitationService {
  private apiUrls: { [key in 'bank' | 'pgl' | 'smt']: string } = {
    bank: environment.apiBankUrl, 
    pgl: environment.apiPglUrl,
    smt: environment.apiSmtUrl,
  };
  private getBaseUrl(): string {
    const userType = this.getUserType();
    return this.apiUrls[userType??'smt']+'/habilitation/';
  }
  private getUserType(): 'bank' | 'pgl' | 'smt' {
    const token = localStorage.getItem('x-access-token') || ''; // Fallback to an empty string if null
    if (!token) return 'smt';

    try {
      const decodedToken: any = jwtDecode(token);
      return decodedToken.type as 'bank' | 'pgl' | 'smt';
    } catch (error) {
      console.error('Error decoding token:', error);
      return 'smt';
    }
  } 
    
    constructor(private http: HttpClient) { }
    public habilitations: Habilitation[] = [
    
    ];
    public habilitations$ = new Subject<Habilitation[]>();
 
    createwithoutfile(habilitation: Habilitation) {
      return new Promise((resolve, reject) => {
        const baseUrl = this.getBaseUrl();
        this.http.post(`${baseUrl}`, habilitation).subscribe(
          (response) => {
            resolve(response);

          },
          (error) => {
            reject(error);
          },
        );
      });
    }
    gethabilitationss() {
      const baseUrl = this.getBaseUrl();
        this.http.get(`${baseUrl}`).subscribe(
          (habilitations: Habilitation[]) => {
            if (habilitations) {
              this.habilitations = habilitations;
              this.emithabilitationss();

            }
          },
          (error) => {
            console.log(error);
          }
        );
      }
    
      emithabilitationss() {
        this.habilitations$.next(this.habilitations);
      }
      getHabilitationreqById(id: string) {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.get(`${baseUrl}${id}`).subscribe(
            (response) => {
              resolve(response);
            },
            (error) => {
              reject(error); 
            }
          );
        });
      }
      gethabilitation(userId: string) {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.post(`${baseUrl}`,{userId}).subscribe(
            (habilitations: Habilitation[]) => {
              if (habilitations) {
                this.habilitations = habilitations;
                this.emithabilitationss();
              }
            },
            (error) => {
              console.log(error);
            }
          );
        });
      }
      
   /* geexistentthabilitation(userId: string,annee:string,mois:string,source:string) 
    {
return new Promise((resolve, reject) => {
        this.http.post(API_URL_cloud+'/anneemois/',{userId,annee,mois,source}).subscribe(
          (response) => {
            resolve(response);
          },
          (error) => {
            reject(error); 
          }
        );
      });

      }*/
      
    /*  create(habilitation: Habilitation) {
        return new Promise((resolve, reject) => {
          
          this.http.post(API_URL_cloud, habilitation).subscribe(
            (response) => {
              resolve(response);

            },
            (error) => {
              reject(error);
            },
          );
        });
      }*/
    
     
    
     /* modify(id: string, habilitationreq: Habilitation, image: File | string) {
        return new Promise((resolve, reject) => {
          let habilitationreqData: Habilitation | FormData;
          if (typeof image === 'string') {
            
            habilitationreqData = habilitationreq;
          } else {
            habilitationreqData = new FormData();
            habilitationreqData.append('habilitationreq', JSON.stringify(habilitationreq));
            habilitationreqData.append('image', image, habilitationreq.email);
          }
          this.http.put(API_URL_cloud + id, habilitationreqData).subscribe(
            (response) => {
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
        });
      }*/
      modifyhabilitationreqById(id: string, habilitation: Habilitation) {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.put(`${baseUrl}${id}`, habilitation).subscribe(
            (response) => {
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
        }); 
      }
     /* completehabilitationreqById(id: string, habilitation: Habilitation) {
        return new Promise((resolve, reject) => {
          
            
          
          this.http.put(API_URL_cloud+'modify/'+ id, habilitation).subscribe(
            (response) => {
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
        });
      }*/
    
      deletehabilitationById(id: string) {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.delete(`${baseUrl}${id}`).subscribe(
            (response) => {
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
        });
      }  
      deletehabilitationss() {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.delete(`${baseUrl}`).subscribe(
            (response) => {
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
        });
      }
    }
